import { useParams } from 'react-router-dom';

import { ModelParams } from 'types/route_params';

import { useAdminMarketplaceModels } from 'hooks/api/useModels';
import { useAdminMarketplaceModel } from 'hooks/api/useMarketplaceModel';

import { NotFound } from 'views/NotFound/NotFound';

import EmptyIllustration from 'analytics-library/images/empty-models-illustration.svg?react';
import { MarketplaceModelDetail } from './MarketplaceModelDetail';

export type ModelFieldValues = {
  name: string;
  description?: string;
  capability?: string;
  architecture?: string;
  weights_file?: FileList;
  metadata_file?: FileList | '';
};

export function MarketplaceModelDetailContainer() {
  const { modelID } = useParams<ModelParams>();
  const { isLoading } = useAdminMarketplaceModels();
  const { data: model } = useAdminMarketplaceModel(modelID);

  if (isLoading) {
    return (
      <div className="loading-spinner-wrap is-fullscreen">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  if (!model) {
    return (
      <NotFound entity="model" returnTo="/admin" image={EmptyIllustration} />
    );
  }

  return <MarketplaceModelDetail model={model} />;
}
